import { usePermissions } from '@/contexts/PermissionsContext';
import { savRemindersService } from '@/services/savRemindersService';
import { useQuery } from '@tanstack/react-query';

export const SAV_REMINDERS_KEY = ['sav-reminders'] as const;

/** Rythme par défaut de la fenêtre d'alerte (heures) si la base ne le donne pas */
export const DEFAULT_ALERT_REPEAT_HOURS = 4;

/**
 * Rappels « À faire » (cloche) et dossiers non traités (fenêtre d'alerte) du personnel SAV, en UNE requête toutes les 60 s
 * (comme les badges, sans Realtime). AUCUNE requête sans le droit « SAV du site » (la base renvoie de toute façon des listes vides).
 * En cas d'erreur : valeur indéfinie (la pastille reste masquée, la fenêtre ne s'ouvre pas), nouvel essai à l'intervalle suivant.
 */
export function useSavReminders() {
  const { hasPermission, isLoading } = usePermissions();
  const allowed = !isLoading && hasPermission('sav_requests');
  const query = useQuery({
    queryKey: SAV_REMINDERS_KEY,
    queryFn: () => savRemindersService.getOverview(),
    enabled: allowed,
    staleTime: 30_000,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
    retry: false,
  });
  return {
    allowed,
    reminders: query.data?.reminders ?? [],
    alerts: query.data?.alerts ?? [],
    visitsToday: query.data?.visitsToday ?? [],
    alertRepeatHours: query.data?.alertRepeatHours ?? DEFAULT_ALERT_REPEAT_HOURS,
    count: allowed && query.data !== undefined ? query.data.reminders.length : undefined,
    isError: query.isError,
    isLoading: query.isLoading,
    refetch: query.refetch,
  };
}
